import View from './view.js';
import icons from 'url:../../img/icons.svg';

class AddRecipeView extends View {
  _parentElement = document.querySelector(`.upload`);
  _message = `Redipe was succesfully uploaded.`;
  _window = document.querySelector(`.add-recipe-window`);
  _overlay = document.querySelector(`.overlay__add-recipe-window`);
  _btnOpen = document.querySelector(`.nav__btn--add-recipe`);
  _btnClose = document.querySelector(`.btn--close-modal`);
  _addIngBtn = document.querySelector(`.btn--add-ingredient`);

  constructor() {
    super();
    this._addHandlerShowWindow();
    this._addHandlerCloseWindow();
    this._addHandlerAddIngredient(this._addIngredient.bind(this));
    this._addHandlerRemoveIngredient(this._removeIngerdient);
  }

  addHandlerUpload(handler) {
    this._parentElement.addEventListener(`submit`, function (e) {
      e.preventDefault();
      const dataArr = [...new FormData(this)];
      const data = Object.fromEntries(dataArr);
      handler(data);
    });
  }

  toggleWindow() {
    this._window.classList.toggle(`hidden`);
    this._overlay.classList.toggle(`hidden`);
  }

  _clearAddRecipeForm() {
    const markup = `
    <div class="upload__column upload__column--recipe-data">
      <h3 class="upload__heading">Recipe data</h3>
      <label>Title</label>
      <input required name="title" type="text" />
      <label>URL</label>
      <input required name="sourceUrl" type="text" />
      <label>Image URL</label>
      <input required name="image" type="text" />
      <label>Publisher</label>
      <input required name="publisher" type="text" />
      <label>Prep time</label>
      <input required name="cookingTime" type="number" />
      <label>Servings</label>
      <input required name="servings" type="number" />
    </div>
    <div class="upload__column upload__column--ingredients">
      <h3 class="upload__heading">Ingredients</h3>
      <a class="btn btn--add-ingredient">
        <svg>
          <use href="${icons}#icon-plus-circle"></use>
        </svg>
        <span>Add Ingredient</span>
      </a>
      <div class="upload__column--ingredients-items"></div>
    </div>

      <button class="btn upload__btn">
        <svg>
          <use href="${icons}#icon-upload-cloud"></use>
        </svg>
        <span>Upload</span>
      </button>
    </form>
    `;
    this._clear();
    this._parentElement.insertAdjacentHTML(`afterbegin`, markup);
    this._addIngBtn = document.querySelector(`.btn--add-ingredient`);
  }
  _addHandlerShowWindow() {
    this._btnOpen.addEventListener(`click`, this.toggleWindow.bind(this));
    this._clearAddRecipeForm();
  }

  _addHandlerCloseWindow() {
    this._btnClose.addEventListener(`click`, this.toggleWindow.bind(this));
    this._overlay.addEventListener(`click`, this.toggleWindow.bind(this));
  }

  _addIngredient() {
    const ingNum =
      +this._parentElement.querySelector(`.upload__column--ingredients-items`)
        .lastElementChild?.dataset.number || 0;

    const markup = `
       <label data-number=${ingNum + 1} name="ing${
      ingNum + 1
    }">Ingredient</label>
          <input data-number=${ingNum + 1}
            type="text"            
            name="ing${ingNum + 1}-quantity"
            placeholder="Quantity'"
          />
          <input data-number=${ingNum + 1}
            type="text"            
            name="ing${ingNum + 1}-unit"
            placeholder="Unit"
          />
          <input data-number=${ingNum + 1}
            type="text"
            required
            name="ing${ingNum + 1}-description"
            placeholder="Description"
          />
          <a data-number=${
            ingNum + 1
          } class="btn btn--inline btn--remove-ingredient">X</a>
    `;

    this._parentElement
      .querySelector(`.upload__column--ingredients-items`)
      .insertAdjacentHTML(`beforeend`, markup);
  }

  _addHandlerAddIngredient(handler) {
    this._parentElement.addEventListener(`click`, function (e) {
      const btn = e.target.closest(`.btn--add-ingredient`);
      if (!btn) return;
      handler();
    });
  }

  _removeIngerdient(dataNumber) {
    const elemnts = document
      .querySelector(`.upload__column--ingredients-items`)
      .querySelectorAll(`*`);
    elemnts.forEach(el => {
      if (+el.dataset.number === dataNumber) {
        el.remove();
      }
    });
  }
  _addHandlerRemoveIngredient(handler) {
    this._parentElement.addEventListener(`click`, function (e) {
      const btn = e.target.closest(`.btn--remove-ingredient`);
      if (!btn) return;
      const dataNumber = +btn.dataset.number;
      handler(dataNumber);
    });
  }
}

export default new AddRecipeView();
